const Index = () => import(/* webpackChunkName: "knowledge" */'@/components/pages/knowledge/Index.vue');
const Layout = () => import(/* webpackChunkName: "base" */'@/components/common/Layout');

export default [
  {
    path: '/knowledge',
    component: Layout,
    meta: {
      roles: ['KNOWLEDGE_QUERY'],
    },
    children: [{
      path: '',
      name: 'knowledge',
      component: Index,
      meta: {
        roles: [],
        title: '安全知识库',
        icon: 'knowledge',
        activeMenu: '/knowledge',
        componentName: 'Knowledge',
        breadcrumb: [
          {
            name: '首页',
            path: '/home'
          },
          {
            name: '安全知识库',
            path: '/knowledge'
          }
        ]
      }
    }]
  }
];



// WEBPACK FOOTER //
// ./src/router/knowledge.js